// Native & external imports
import { Pipe, PipeTransform, inject } from "@angular/core";
// Services
import { AppLocalization } from '@icamppro-customer-portal/shared/cmp-base';

@Pipe({ name: "localeordinal", standalone: false })
export class LocaleOrdinalPipe implements PipeTransform {
  private _appLocalization = inject(AppLocalization);

  transform(n: number, keepNumber: boolean = true) {
    return this._appLocalization.client.oridinal(n, keepNumber);
  }
}
